import { Component, Input } from '@angular/core';
import { StatusColor } from '../../models/monitoring.models';

@Component({
  selector: 'app-page-header',
  standalone: true,
  template: `
    <header class="page-header">
      <img class="logo" src="/kuba-logo.png" alt="Kuba" />
      <h1 class="title">{{ title }}</h1>
      @if (subtitle) {
        <p class="subtitle">{{ subtitle }}</p>
      }
    </header>
  `,
  styles: [
    `
      .page-header {
        text-align: center;
        padding: 1rem 1rem 0.5rem;
      }

      .logo {
        height: 2.25rem;
        width: auto;
        margin-bottom: 0.75rem;
      }

      .title {
        margin: 0;
        font-size: 1.35rem;
        font-weight: 700;
        color: #222;
      }

      .subtitle {
        margin: 0.35rem 0 0;
        font-size: 1.5rem;
        font-weight: 700;
        color: #222;
      }
    `,
  ],
})
export class PageHeaderComponent {
  @Input({ required: true }) title!: string;
  @Input() subtitle?: string;
}

@Component({
  selector: 'app-status-pill',
  standalone: true,
  template: `<span class="pill" [class]="color"></span>`,
  styles: [
    `
      .pill {
        display: inline-block;
        width: 3.5rem;
        height: 1.1rem;
        border-radius: 4px;
        vertical-align: middle;
      }

      .green {
        background: #43a047;
      }
      .yellow,
      .orange {
        background: #fb8c00;
      }
      .red {
        background: #e53935;
      }
      .grey {
        background: #9e9e9e;
      }
    `,
  ],
})
export class StatusPillComponent {
  @Input({ required: true }) color!: StatusColor;
}

@Component({
  selector: 'app-back-button',
  standalone: true,
  template: `
    <footer class="footer">
      <button type="button" class="btn-back" (click)="onClick()">Retour</button>
    </footer>
  `,
  styles: [
    `
      .footer {
        padding: 1rem;
        display: flex;
        justify-content: center;
      }

      .btn-back {
        background: #1565c0;
        color: #fff;
        border: none;
        border-radius: 6px;
        padding: 0.65rem 2.5rem;
        font-size: 1rem;
        font-weight: 600;
        cursor: pointer;
        min-width: 8rem;
      }

      .btn-back:hover {
        background: #0d47a1;
      }
    `,
  ],
})
export class BackButtonComponent {
  @Input() backFn?: () => void;

  onClick(): void {
    this.backFn?.();
  }
}
